import { Check } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const items = [
  "Une situation se répète, malgré vos efforts",
  "Vous êtes bloqué dans une relation",
  "Vous ne comprenez pas certaines réactions",
  "Vous ressentez un poids sans explication",
];

export default function AteliersProblem() {
  return (
    <section
      data-testid="ateliers-problem"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
            — Reconnaissance
          </span>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
            Vous vous reconnaissez si…
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-x-10 gap-y-4">
          {items.map((p, i) => (
            <Reveal key={p} delay={i * 0.06}>
              <div
                data-testid={`ateliers-problem-item-${i}`}
                className="group flex items-start gap-4 py-5 border-b border-[#DDD7E2]"
              >
                <span className="mt-1 flex-shrink-0 w-8 h-8 rounded-full bg-[#F3EEF4] flex items-center justify-center group-hover:bg-[#C98FA3] transition-colors">
                  <Check className="w-4 h-4 text-[#C98FA3] group-hover:text-white transition-colors" />
                </span>
                <p className="text-base md:text-lg text-[#1E1E2A] leading-relaxed">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
